// extracted by mini-css-extract-plugin
export default {"wrapper":"ShiftActionsModal--wrapper--0020fe"};